var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBorFavicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 100,
    width: 250,
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 250 100",
    style: {
      enableBackground: "new 0 0 250 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill:transparent;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 102,
    width: 252,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    id: "svg_4",
    d: "m205.899991,4.7c0.3,0.1 0.5,0.3 0.8,0.3c9.6,0.8 18.1,4.3 25.4,10.5c8.1,6.8 13.2,15.4 15.3,25.8c0.9,4.6 1.1,9.2 0.6,13.9c-1.7,15.4 -11.7,29.7 -27,36.3c-3.9,1.7 -8,2.9 -12.2,3.3c-2,0.2 -4,0.4 -6,0.4c-23.1,0 -46.1,0 -69.2,0c-0.5,0 -0.9,0 -1.5,0c-0.2,-1.2 -0.1,-2.3 -0.1,-3.4c0,-1.1 0,-2.3 0,-3.4s0,-2.3 0,-3.4c0,-1.1 0,-2.2 0,-3.5c0.6,0 1.1,0 1.5,0c23.2,0 46.3,0 69.5,0c14.9,0 27.9,-10.4 30.9,-25c3.7,-17.4 -7.7,-33.7 -24.1,-37.3c-2.5,-0.5 -4.9,-0.8 -7.5,-0.8c-22.9,0 -45.8,0 -68.7,0c-0.5,0 -1,0 -1.6,0c0,-0.5 -0.1,-0.9 -0.1,-1.4c0,-3.7 0,-7.4 0,-11.1c0,-0.4 -0.1,-0.8 -0.1,-1.3c24.8,0.1 49.4,0.1 74.1,0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_5",
    d: "m118.699991,4.7c0,0.4 -0.1,0.8 -0.1,1.3c0,3.7 0,7.4 0,11.1c0,0.4 -0.1,0.8 -0.1,1.4c-0.6,0 -1.1,0 -1.6,0c-22.9,0 -45.9,0 -68.8,0c-4.8,0 -9.5,0.8 -13.9,3c-9.5,4.7 -15.6,12.1 -17.6,22.6c-2.1,11 1,20.6 8.9,28.6c4.7,4.7 10.5,7.6 17.2,8.5c1.7,0.2 3.4,0.4 5.1,0.4c23.1,0 46.2,0 69.3,0c0.5,0 0.9,0 1.5,0c0.1,4.6 0,9 0.1,13.6c-0.6,0 -1,0.1 -1.5,0.1c-17.3,0 -34.5,0 -51.8,0c-5.8,0 -11.7,0 -17.5,0c-9,0 -17.3,-2.3 -24.9,-7.3c-10.8,-7.1 -17.4,-17 -19.9,-29.7c-0.8,-4.1 -1,-8.3 -0.6,-12.4c1.1,-10.4 5.2,-19.4 12.4,-26.9c6,-6.3 13.3,-10.6 21.8,-12.6c2.3,-0.6 4.7,-0.8 7.1,-1.2c0.3,-0.1 0.6,-0.2 0.9,-0.3c24.7,-0.2 49.3,-0.2 74,-0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_9",
    d: "m177.299991,50c-0.2,-7.5 5.8,-15.6 15.6,-15.6c9.4,0 15.7,7.6 15.7,15.7c0,8.5 -6.8,15.7 -15.7,15.7c-9.3,-0.2 -15.8,-7.9 -15.6,-15.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_10",
    d: "m73.299991,50c0.2,7.8 -6.1,15.6 -15.5,15.7c-8.7,0.1 -15.7,-7 -15.8,-15.6c0,-8.8 7.2,-15.7 15.7,-15.7c8.8,0 15.8,7.4 15.6,15.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorFavicon);
export default __webpack_public_path__ + "static/media/bor-favicon.1ab4a35ae6e377b3bb1bd8a19488a517.svg";
export { ForwardRef as ReactComponent };